import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "ui/components/dialog";
import { Button } from "ui/components/button";
import ButtonWithLoading from "@/components/button-with-loading";

export const ConfirmationDialog = ({
    open,
    onOpenChange,
    title,
    description,
    onConfirm,
    isLoading,
    onCancel,
    descriptionClassName,
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className={descriptionClassName}>
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2">
                    <Button variant="outline" onClick={onCancel}>
                        Cancel
                    </Button>
                    <ButtonWithLoading
                        onClick={onConfirm}
                        isLoading={isLoading}
                        variant="default"
                    >
                        Confirm
                    </ButtonWithLoading>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
